module.exports = __webpack_public_path__ + "img/铺货管理系统.c6cee279.jpg";